import { render, staticRenderFns } from "./pro-tree-app-detail.vue?vue&type=template&id=4aef9e34";
import script from "./pro-tree-app-detail.vue?vue&type=script&lang=js";
export * from "./pro-tree-app-detail.vue?vue&type=script&lang=js";
import style0 from "./pro-tree-app-detail.vue?vue&type=style&index=0&id=4aef9e34&prod&lang=less";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;